import {http} from '@/axios'

export default function download(url, name, ext, exactUrl, type) {
  return http({
    method: 'GET',
    url: exactUrl ? url : `/api/files/download-file?link=` + url,
    responseType: 'blob', // important
  }).then(response => {
    forceFileDownload(response, name, ext, type)
    return true
  }).catch(e => {
    return e
  })
}

export function forceFileDownload(response, name, ext, type) {
  const blob = new Blob([response.data], {
    type: type
  })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  if (name && ext) {
    link.setAttribute('download', `${name}.${ext}`)
  } else if (name) {
    link.setAttribute('download', `${name}`)
  } else {
    link.setAttribute('download', '')
  }
  link.click()
  URL.revokeObjectURL(link.href)
}

export function downloadByLink(link) {
  const a = document.createElement('a');
  a.href = link;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
